import { render, staticRenderFns } from "./ListRecursos.vue?vue&type=template&id=6e10bf12&scoped=true"
import script from "./ListRecursos.vue?vue&type=script&lang=js"
export * from "./ListRecursos.vue?vue&type=script&lang=js"
import style0 from "./ListRecursos.vue?vue&type=style&index=0&id=6e10bf12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10bf12",
  null
  
)

export default component.exports